import React from 'react'
import { withRouter } from 'react-router-dom'

import { REDIRECT_CONTROLLER } from '../../constants/routes'
import { LandingPageHeadline, LandingPageLogo } from '../StyledComponents/Pages/Landing'
import { FillerDiv, CenteredDivWithMargin } from '../StyledComponents/Fillers'

const logo = require('../../assets/images/Logo/FlowerAILogo.svg')

class LandingPage extends React.Component {
    render() {
        const { history } = this.props

        return (
            <FillerDiv onClick={() => history.push(REDIRECT_CONTROLLER)} >
                <LandingPageHeadline>Flower AI</LandingPageHeadline>
                <LandingPageLogo src={logo} />
                <CenteredDivWithMargin bottom="50">Klicke, um zu starten!</CenteredDivWithMargin>
            </FillerDiv>
        )
    }
}

export default withRouter(LandingPage)



// WEBPACK FOOTER //
// ./src/components/pages/Landing.js